import { storePreloadedStateCreator } from '@flecto-io/core/src/store'

export function mountPreloadedState() {
  const reduxStore = storePreloadedStateCreator({})
  const { dispatch } = reduxStore

  return {
    dispatch,
    getState: reduxStore.getState,
  }
}
